// TODO: message.constantsに統合
export const EMPTY_LABEL = '-'
